import { Suspense, lazy } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { AppShell } from "./AppShell";
import { appPath } from "./routes";
import { NaoEncontradaPage } from "../pages/NaoEncontrada";
import { InicioPage } from "../pages/InicioPage";
import { TarefasPage } from "../pages/TarefasPage";
import { NotificacoesPage } from "../pages/NotificacoesPage";
import { ClientesPage, LeadsPage, LixeiraPage } from "../pages/ListaPage";
import { EmpresaPage, EmpresasPage } from "../pages/EmpresasPage";
import { PerfilPage } from "../pages/PerfilPage";
import { FunisPage } from "../pages/FunisPage";
/**
 * O editor de funil carrega sob demanda.
 *
 * Ele arrasta o canvas inteiro (`@xyflow/react`) junto, e quem abre o CRM para
 * ver leads não deveria esperar por ele. O resto das telas continua no pacote
 * principal, porque são a navegação do dia a dia.
 */
const FunilEditorPage = lazy(() =>
  import("../pages/FunilEditorPage").then((mod) => ({ default: mod.FunilEditorPage })),
);
import { MensagensPage } from "../pages/MensagensPage";
import { AnalisePage } from "../pages/AnalisePage";
import { ConfiguracoesPage } from "../pages/ConfiguracoesPage";
import { ModelosPage } from "../pages/ModelosPage";
import { PortalPage } from "../pages/PortalPage";

/**
 * Árvore de rotas da aplicação, montada na raiz desde o corte de 21/09/2026.
 *
 * O endereço inexistente tem tela própria: declara o que houve e oferece a
 * saída, em vez de abrir superfície vazia (AGENTS §18).
 */
export function AppRoutes() {
  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route index element={<InicioPage />} />
        <Route path="leads" element={<LeadsPage />} />
        <Route path="leads/:leadId" element={<PerfilPage />} />
        <Route path="clientes" element={<ClientesPage />} />
        <Route path="empresas" element={<EmpresasPage />} />
        <Route path="empresas/:companyId" element={<EmpresaPage />} />
        <Route path="lixeira" element={<LixeiraPage />} />
        <Route path="mensagens" element={<MensagensPage />} />
        {/* A Inbox é um recorte de Mensagens, não outra tela; o endereço
            documentado continua abrindo (§4). */}
        <Route
          path="mensagens/inbox"
          element={<Navigate to={`${appPath("mensagens")}?canal=email`} replace />}
        />
        <Route path="funis" element={<FunisPage />} />
        <Route
          path="funis/:funnelId"
          element={
            <Suspense fallback={<div className="cx-route-loading">Abrindo o editor…</div>}>
              <FunilEditorPage />
            </Suspense>
          }
        />
        {/* O protótipo fundiu Fluxos ao funil: o processo vive no editor do
            funil. O endereço antigo continua válido e leva à relação. */}
        <Route path="fluxos" element={<Navigate to={appPath("funis")} replace />} />
        <Route path="analise" element={<AnalisePage />} />
        <Route path="tarefas" element={<TarefasPage />} />
        <Route path="notificacoes" element={<NotificacoesPage />} />
        <Route path="configuracoes/*" element={<ConfiguracoesPage />} />
        <Route path="modelos" element={<ModelosPage />} />
        <Route path="portal/:leadId" element={<PortalPage />} />
        <Route path="*" element={<NaoEncontradaPage />} />
      </Route>
    </Routes>
  );
}
